import Order from "../../Types/Order";
import Box from "../../Types/Box";

/**
 * Groups the boxes in an order by their IDs, calculates the number of items in each group,
 * and sorts the resulting groups based on the `isTypeFormule` property.
 *
 * @param {Order} order - The order containing the boxes to be grouped.
 * @returns {Array<Box> | null} - An array of grouped boxes with the number of items in each group,
 *                                or `null` if the order is not provided.
 */
export const getOrderBoxes = (order: Order): Array<Box> | null => {
    if (!order) return null;

    const groupBoxes = order.boxes.reduce<Record<string, Box[]>>((acc, box) => {
        if (!acc[box.id]) acc[box.id] = [];
        acc[box.id].push(box);
        return acc;
    }, {});

    return Object.values(groupBoxes)
        .map((boxes) => ({
            ...boxes[0], nbItems: boxes.length,
        }))
        .sort((a, b) => Number(b.isTypeFormule) - Number(a.isTypeFormule));
}

export default { getOrderBoxes };
